// src/components/RecipeCard.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // We'll use this to make the card clickable

function RecipeCard({ recipe }) {
  // A helper function to generate the URL for this specific recipe
  // We'll create the RecipePage later to handle this URL
  const recipeLink = `/recipe/${recipe.id}`;

  return (
    <Card style={{ width: '18rem' }} className="m-2"> 
      {/* m-2 adds a small margin around the card */}
      <Card.Img variant="top" src={recipe.image} />
      <Card.Body>
        <Card.Title>{recipe.title}</Card.Title>
        <Card.Text>
          <strong>Ready in:</strong> {recipe.prepTime + recipe.cookTime} mins<br />
          <strong>Serves:</strong> {recipe.servings}
        </Card.Text>
        {/* Link makes it a clickable route, Button makes it look like a button */}
        <Link to={recipeLink}>
          <Button variant="primary">View Recipe</Button>
        </Link>
      </Card.Body>
    </Card>
  );
}

export default RecipeCard;